



























import { defineComponent, PropType } from '@vue/composition-api';
import { VueConstructor } from 'vue';
import HelpTooltip from '../dropdowns/HelpTooltip.vue';

export default defineComponent({
	components: { HelpTooltip },
	props: {
		tag: {
			type: String as PropType<null | string | VueConstructor>,
			default: 'label',
		},
		labelClass: {
			type: [Object, String, Array],
			default: '',
		},
		required: Boolean,
		withHelp: Boolean,
	},
	setup() {
		return {};
	},
});
